import { useState } from 'react'

import { meetingApi } from '../api'

const useUploadAssistContextDocument = () => {
  const [isUploading, setIsUploading] = useState(false)

  const uploadAssistContextDocument = async (meetingId: string, file: File) => {
    setIsUploading(true)
    try {
      return await meetingApi.uploadAssistContextDocument(meetingId, { file })
    } catch (error) {
      console.error('Failed to upload context document', error)
    } finally {
      setIsUploading(false)
    }
  }

  return { isUploading, uploadAssistContextDocument }
}

export default useUploadAssistContextDocument
